import {
  ERollingOffersInternalViewModel,
  HugeRollingOffer,
  MatchMastersRollingOffer,
  StudioDefaultRollingOffer
} from '@appcharge/shared-ui';

export const mapRollingOffers: Record<ERollingOffersInternalViewModel, any> = {
  [ERollingOffersInternalViewModel.HUGE]: HugeRollingOffer,
  [ERollingOffersInternalViewModel.MATCH_MASTERS]: MatchMastersRollingOffer,
  [ERollingOffersInternalViewModel.STUDIO_DEFAULT]: StudioDefaultRollingOffer
};

export const mapViewModelRollingDisplayName: Record<
  ERollingOffersInternalViewModel,
  string
> = {
  [ERollingOffersInternalViewModel.HUGE]: 'Huge',
  [ERollingOffersInternalViewModel.MATCH_MASTERS]: 'Match Masters',
  [ERollingOffersInternalViewModel.STUDIO_DEFAULT]: 'Studio'
};
